import { Selector, State } from "./types";
import { Identifiable, Resource } from "@planzone/dto";

function get(getState: () => State, resource: Identifiable<Resource>) {
  return getState().find((res) => res.resource.uuid === resource.uuid);
}

function createSelector(getState: () => State): Selector {
  return {
    getResourceSubordinates(resource: Identifiable<Resource>) {
      const state = get(getState, resource);

      return state ? state.resources : [];
    },
    isRetrieveResourceSubordinatesRequestFailure(
      resource: Identifiable<Resource>,
    ) {
      const state = get(getState, resource);

      return state ? state.request.isFailure : false;
    },
    isRetrieveResourceSubordinatesRequestPending(
      resource: Identifiable<Resource>,
    ) {
      const state = get(getState, resource);

      return state ? state.request.isPending : false;
    },
    isRetrieveResourceSubordinatesRequestSuccess(
      resource: Identifiable<Resource>,
    ) {
      const state = get(getState, resource);

      return state ? state.request.isSuccessful : false;
    },
    canLoadMoreResourceSubordinates(resource: Identifiable<Resource>) {
      const state = get(getState, resource);

      return state ? state.canLoadMore : false;
    },
    getResourceSubordinatesCurrentPage(resource: Identifiable<Resource>) {
      const state = get(getState, resource);

      return state ? state.currentPage : 0;
    },
  };
}

export { createSelector };
